(ns frontend.ui.component.file-input.core
  (:require
   [frontend.ui.component.file-input.event :as evt]
   [re-frame.core :as rf]))

(defn dispatch-upload-file
  [{:keys [owning-entity-id
           owning-entity-ref-path
           attachments-ref-path
           dispatch-on-upload-success
           dispatch-on-upload-progress]} file]
  (let [upload-descriptor {:file  file
                           :owning-entity-id owning-entity-id
                           :token nil}]
    (rf/dispatch [::evt/upload-file-socket
                  owning-entity-ref-path
                  attachments-ref-path
                  dispatch-on-upload-success
                  dispatch-on-upload-progress
                  upload-descriptor])))
